import React, { useState } from 'react';
import { assetUrl } from './scenario-api';
import { AssetPickerModal } from './AssetPickerModal';
import { backgroundAccentHue } from './inline-background-model';
import inline from './inline-editor.module.css';

export interface BackgroundSectionToggleProps {
  sceneCount: number;
  collapsed: boolean;
  onToggle: () => void;
}

interface InlineBackgroundPanelProps {
  scenarioId: string;
  backgroundPath: string;
  editMode: boolean;
  onPick: (path: string) => void;
  onRemove: () => void;
  sectionToggle?: BackgroundSectionToggleProps;
}

export const InlineBackgroundPanel: React.FC<InlineBackgroundPanelProps> = ({
  scenarioId,
  backgroundPath,
  editMode,
  onPick,
  onRemove,
  sectionToggle,
}) => {
  const [pickerOpen, setPickerOpen] = useState(false);
  const accentHue = backgroundAccentHue(backgroundPath);

  return (
    <div
      className={inline.bgRow}
      style={{ '--bg-accent-h': accentHue } as React.CSSProperties}
      role="group"
      aria-label={`Background : ${backgroundPath}`}
    >
      {sectionToggle && (
        <button
          type="button"
          className={inline.bgSectionToggle}
          onClick={sectionToggle.onToggle}
          aria-expanded={!sectionToggle.collapsed}
          title={
            sectionToggle.collapsed
              ? `Afficher ${sectionToggle.sceneCount} scène(s)`
              : `Masquer ${sectionToggle.sceneCount} scène(s)`
          }
        >
          <span
            className={`${inline.bgSectionChevron} ${sectionToggle.collapsed ? '' : inline.bgSectionChevronOpen}`}
            aria-hidden
          >
            ▸
          </span>
        </button>
      )}

      <span className={inline.bgRowIcon} title="Background" aria-hidden>
        🖼
      </span>

      <img
        className={inline.bgThumb}
        src={assetUrl(scenarioId, backgroundPath)}
        alt=""
      />

      <span className={inline.bgLabel}>{backgroundPath}</span>

      {sectionToggle && (
        <span className={inline.bgSectionCount}>
          {sectionToggle.collapsed
            ? `${sectionToggle.sceneCount} scène(s) masquée(s)`
            : `${sectionToggle.sceneCount} scène(s)`}
        </span>
      )}

      {editMode && (
        <div className={inline.bgActions}>
          <button
            type="button"
            className={inline.stageLink}
            onClick={() => setPickerOpen(true)}
            title="Changer le background"
          >
            Parcourir
          </button>
          <button
            type="button"
            className={inline.stageLink}
            onClick={onRemove}
            title="Retirer le background de cette scène"
          >
            Retirer
          </button>
        </div>
      )}

      {pickerOpen && (
        <AssetPickerModal
          scenarioId={scenarioId}
          value={backgroundPath}
          subdir="backgrounds"
          onSelect={onPick}
          onClose={() => setPickerOpen(false)}
        />
      )}
    </div>
  );
};
